var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_vm._l((_vm.list.slice(0, _vm.limit)),function(v,idx){return _c('li',{key:idx},[_vm._v("\n    "+_vm._s(v)+"\n  ")])}),(_vm.list.length > _vm.limit)?_c('li',[_vm._v("...")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }